module.exports = __webpack_public_path__ + "static/media/avatar_ladybug.bd5a29e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_ladybug.png
// module id = 387
// module chunks = 0